import { render } from "./AgeDropDown.vue?vue&type=template&id=1e7a747a"
import script from "./AgeDropDown.vue?vue&type=script&lang=js"
export * from "./AgeDropDown.vue?vue&type=script&lang=js"
script.render = render

export default script